import React from 'react';

const ArrowLeft = ({ width, height, color }) => (
  <svg width={width || '16'} height={height || '16'} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.4711 4.47145C10.7314 4.2111 10.7314 3.78899 10.4711 3.52864C10.2107 3.26829 9.78862 3.26829 9.52827 3.52864L5.52827 7.52864C5.27588 7.78102 5.26705 8.18741 5.50824 8.45052L9.17491 12.4505C9.4237 12.7219 9.84541 12.7403 10.1168 12.4915C10.3882 12.2427 10.4066 11.821 10.1578 11.5496L6.92243 8.02009L10.4711 4.47145Z" fill={color || '#BFBFBF'} />
  </svg>
);

export default ArrowLeft;